<template>
  <div class="widget-search-box">
    <el-input
      v-show="shouldShowInput"
      :placeholder="placeholder"
      v-model="query"
      v-on:change="onChange"
      clearable>
    </el-input>
    <i class="el-icon-search" @click="toggle"></i>
  </div>
</template>

<script>
export default {
  name: 'WdigetSearchBox',
  props: ['placeholder'],
  data () {
    return {
      showInput: false,
      query: ''
    }
  },
  methods: {
    toggle () {
      this.showInput = !this.showInput
    },
    onChange (val) {
      this.$emit('search', val)
    }
  },
  computed: {
    shouldShowInput () {
      return this.showInput || this.query !== ''
    }
  }
}
</script>
<style lang="scss">
  .widget-search-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 300px;
    .el-icon-search {
      font-weight: bold;
      font-size: 150%;
      margin-left: 10px;
      cursor: pointer;
      transition: .2s ease-in-out color;
    }
  
    .el-input__inner {
      background: transparent;
      border: none;
      border-bottom: 1px solid#ccc;
    }

    &:focus-within {
      .el-input__inner,
      .el-icon-search {
        color: #409EFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// widgetSearchBox.vue?58a2b485